export default __webpack_public_path__ + "static/media/financas1.9c2e5951.jpg";